import {v$,toggleClass,parentParent, Parents} from './helpers.js';
let contactsPopup = v$('.header-info-contacts_popup')[0],
    toggleBtn     = v$('.header-all_contacts')[0];


toggleBtn.addEventListener('click',e => {
    toggleClass(contactsPopup,'active');
})
document.body.addEventListener('click',e => {
    let isPopup  = Parents(e.target,'header-info-contacts_popup',3).className ? Parents(e.target,'header-info-contacts_popup',3).className.includes('header-info-contacts_popup') : false;
    if(!isPopup && e.target !== toggleBtn){
        contactsPopup.classList.remove('active');
    }
})